import { CmsComponent } from './cms.model';

export interface UspComponentModel extends CmsComponent {
  content?: string;
  direction?: string;
  isCartUsp?: boolean;
}

export enum UspDirection {
  VERTICAL = 'VERTICAL',
  HORIZONTAL = 'HORIZONTAL',
}
